import { render, staticRenderFns } from "./DepartmentSelect.vue?vue&type=template&id=5beb001e&"
import script from "./DepartmentSelect.vue?vue&type=script&lang=ts&"
export * from "./DepartmentSelect.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/winfakt-authentication-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5beb001e')) {
      api.createRecord('5beb001e', component.options)
    } else {
      api.reload('5beb001e', component.options)
    }
    module.hot.accept("./DepartmentSelect.vue?vue&type=template&id=5beb001e&", function () {
      api.rerender('5beb001e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/DepartmentSelect.vue"
export default component.exports